import { frontendURL } from 'dashboard/helper/URLHelper';

import Login from './login/Index.vue';
import SamlLogin from './login/Saml.vue';
import Signup from './auth/signup/Index.vue';
import ResetPassword from './auth/reset/password/Index.vue';
import Confirmation from './auth/confirmation/Index.vue';
import VerifyEmail from './auth/verify-email/Index.vue';
import PasswordEdit from './auth/password/Edit.vue';
import PortfolioHome from './portfolio/Home.vue';
import PortfolioFeatures from './portfolio/Features.vue';
import PortfolioWorkflow from './portfolio/Workflow.vue';
import PortfolioPricing from './portfolio/Pricing.vue';
import PortfolioCustomers from './portfolio/Customers.vue';
import PortfolioAerox from './portfolio/Aerox.vue';
import PortfolioPrivacy from './portfolio/Privacy.vue';
import PortfolioCookiePolicy from './portfolio/CookiePolicy.vue';
import PortfolioTerms from './portfolio/Terms.vue';
import PortfolioDpa from './portfolio/Dpa.vue';
import PortfolioBookDemo from './portfolio/BookDemo.vue';
import PortfolioHelpCenter from './portfolio/HelpCenter.vue';
import PortfolioInbox from './portfolio/Inbox.vue';
import PortfolioSecurity from './portfolio/Security.vue';
import PortfolioAbout from './portfolio/About.vue';
import PortfolioContact from './portfolio/Contact.vue';

export default [
  {
    path: '/',
    name: 'portfolio_root',
    component: PortfolioHome,
    meta: { ignoreSession: true },
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    component: PortfolioHome,
    meta: { ignoreSession: true },
  },
  {
    path: '/privacy',
    name: 'portfolio_privacy',
    component: PortfolioPrivacy,
    meta: { ignoreSession: true },
  },
  {
    path: '/cookie-policy',
    name: 'portfolio_cookie_policy',
    component: PortfolioCookiePolicy,
    meta: { ignoreSession: true },
  },
  {
    path: '/terms',
    name: 'portfolio_terms',
    component: PortfolioTerms,
    meta: { ignoreSession: true },
  },
  {
    path: '/dpa',
    name: 'portfolio_dpa',
    component: PortfolioDpa,
    meta: { ignoreSession: true },
  },
  {
    path: '/book-demo',
    name: 'portfolio_book_demo',
    component: PortfolioBookDemo,
    meta: { ignoreSession: true },
  },
  {
    path: '/help-center',
    name: 'portfolio_help_center',
    component: PortfolioHelpCenter,
    meta: { ignoreSession: true },
  },
  {
    path: '/inbox',
    name: 'portfolio_inbox',
    component: PortfolioInbox,
    meta: { ignoreSession: true },
  },
  {
    path: '/security',
    name: 'portfolio_security',
    component: PortfolioSecurity,
    meta: { ignoreSession: true },
  },
  {
    path: '/about',
    name: 'portfolio_about',
    component: PortfolioAbout,
    meta: { ignoreSession: true },
  },
  {
    path: '/contact',
    name: 'portfolio_contact',
    component: PortfolioContact,
    meta: { ignoreSession: true },
  },
  {
    path: '/aerox',
    name: 'portfolio_aerox',
    component: PortfolioAerox,
    meta: { ignoreSession: true },
  },
  {
    path: '/portfolio/aerox',
    name: 'portfolio_aerox_alt',
    component: PortfolioAerox,
    meta: { ignoreSession: true },
  },
  {
    path: '/features',
    name: 'portfolio_features',
    component: PortfolioFeatures,
    meta: { ignoreSession: true },
  },
  {
    path: '/portfolio/features',
    name: 'portfolio_features_alt',
    component: PortfolioFeatures,
    meta: { ignoreSession: true },
  },
  {
    path: '/workflow',
    name: 'portfolio_workflow',
    component: PortfolioWorkflow,
    meta: { ignoreSession: true },
  },
  {
    path: '/portfolio/workflow',
    name: 'portfolio_workflow_alt',
    component: PortfolioWorkflow,
    meta: { ignoreSession: true },
  },
  {
    path: '/pricing',
    name: 'portfolio_pricing',
    component: PortfolioPricing,
    meta: { ignoreSession: true },
  },
  {
    path: '/portfolio/pricing',
    name: 'portfolio_pricing_alt',
    component: PortfolioPricing,
    meta: { ignoreSession: true },
  },
  {
    path: '/customers',
    name: 'portfolio_customers',
    component: PortfolioCustomers,
    meta: { ignoreSession: true },
  },
  {
    path: '/portfolio/customers',
    name: 'portfolio_customers_alt',
    component: PortfolioCustomers,
    meta: { ignoreSession: true },
  },
  {
    path: frontendURL('login'),
    name: 'login',
    component: Login,
    props: route => ({
      config: route.query.config,
      email: route.query.email,
      ssoAuthToken: route.query.sso_auth_token,
      ssoAccountId: route.query.sso_account_id,
      ssoConversationId: route.query.sso_conversation_id,
      authError: route.query.error,
    }),
  },
  {
    path: frontendURL('login/sso'),
    name: 'sso_login',
    component: SamlLogin,
    meta: { requireEnterprise: true },
    props: route => ({
      authError: route.query.error,
      target: route.query.target,
    }),
  },
  {
    path: frontendURL('auth/signup'),
    name: 'auth_signup',
    component: Signup,
    meta: { requireSignupEnabled: true },
  },
  {
    path: frontendURL('auth/confirmation'),
    name: 'auth_confirmation',
    component: Confirmation,
    meta: { ignoreSession: true },
    props: route => ({
      config: route.query.config,
      confirmationToken: route.query.confirmation_token,
      redirectUrl: route.query.route_url,
    }),
  },
  {
    path: frontendURL('auth/verify-email'),
    name: 'auth_verify_email',
    component: VerifyEmail,
    meta: { ignoreSession: true },
    props: () => ({
      email: window.history.state?.email || '',
    }),
  },
  {
    path: frontendURL('auth/password/edit'),
    name: 'auth_password_edit',
    component: PasswordEdit,
    meta: { ignoreSession: true },
    props: route => ({
      config: route.query.config,
      resetPasswordToken: route.query.reset_password_token,
      redirectUrl: route.query.route_url,
    }),
  },
  {
    path: frontendURL('auth/reset/password'),
    name: 'auth_reset_password',
    component: ResetPassword,
  },
];
